import { createContext } from "react";

export const CommonApiDataContext = createContext({})